import {radioAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers, defineStyle} from '@chakra-ui/react'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(radioAnatomy.keys)

const baseStyle = definePartsStyle({
  // define the part you're going to style
  control: {
    borderColor: 'pg50', // change the border color
    _disabled: {
      background: 'pg20',
      borderColor: 'pg50',
      _checked: {
        background: 'pg20',
        borderColor: 'pg50',
      },
    },
  },
})

const lg = defineStyle({
  w: '1.25rem',
  h: '1.25rem',
})

const sm = defineStyle({
  w: '1rem',
  h: '1rem',
})

const xs = defineStyle({
  w: '0.875rem',
  h: '0.875rem',
})

const small = defineStyle({
  w: '1rem',
  h: '1rem',
})

const sizes = {
  lg: definePartsStyle({control: lg}),
  //sm: definePartsStyle({control: sm}),
  small: definePartsStyle({control: small}),
  xs: definePartsStyle({control: xs}),
}
export const RadioStyles = defineMultiStyleConfig({
  baseStyle,
  sizes,
})
